import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { HARYANA_DISTRICTS } from "@/constants/campaign";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SupporterForm = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [district, setDistrict] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/supporters`, { name, phone, district });
      if (res.data.message === "already_registered") {
        toast.success("आप पहले से ही समर्थक के रूप में दर्ज हैं। धन्यवाद!");
      } else {
        toast.success("धन्यवाद! आपका समर्थन दर्ज हो गया है।");
      }
      setName("");
      setPhone("");
      setDistrict("");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "कुछ गड़बड़ हो गई। कृपया पुनः प्रयास करें।");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      data-testid="supporter-form"
      className="bg-white p-6 md:p-8 rounded-lg shadow-xl border border-slate-100 w-full"
    >
      <h3 className="font-heading text-2xl md:text-3xl font-semibold text-slate-900">
        समर्थक बनें
      </h3>
      <p className="text-sm text-slate-500 mt-1 leading-relaxed">
        अपनी जानकारी दर्ज करें और अभियान से जुड़ें
      </p>

      <div className="mt-6 space-y-5">
        <div className="space-y-2">
          <Label htmlFor="supporter-name" className="text-sm font-semibold text-slate-700">
            पूरा नाम
          </Label>
          <Input
            id="supporter-name"
            data-testid="supporter-name-input"
            placeholder="अपना नाम लिखें"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="min-h-12"
            required
            maxLength={60}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="supporter-phone" className="text-sm font-semibold text-slate-700">
            मोबाइल नंबर
          </Label>
          <Input
            id="supporter-phone"
            data-testid="supporter-phone-input"
            type="tel"
            inputMode="numeric"
            placeholder="10 अंकों का मोबाइल नंबर"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className="min-h-12"
            required
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="supporter-district" className="text-sm font-semibold text-slate-700">
            जिला (हरियाणा)
          </Label>
          <Select value={district} onValueChange={setDistrict} required>
            <SelectTrigger
              id="supporter-district"
              data-testid="supporter-district-select"
              className="min-h-12 bg-white"
            >
              <SelectValue placeholder="अपना जिला चुनें" />
            </SelectTrigger>
            <SelectContent className="bg-white max-h-64">
              {HARYANA_DISTRICTS.map((d) => (
                <SelectItem key={d} value={d} data-testid={`district-option-${d.split(" ")[0]}`}>
                  {d}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <Button
          type="submit"
          data-testid="supporter-submit-button"
          disabled={loading}
          className="w-full min-h-12 text-base font-semibold bg-[#FF9933] hover:bg-[#E68A2E] text-white transition-colors duration-300"
        >
          {loading ? "दर्ज हो रहा है..." : "समर्थन दें"}
        </Button>

        <p className="text-xs text-slate-500 leading-relaxed">
          आपकी जानकारी सुरक्षित है और केवल अभियान संचार के लिए उपयोग होगी।{" "}
          <a href="/privacy-policy" className="underline text-[#138808]">
            गोपनीयता नीति
          </a>{" "}
          पढ़ें।
        </p>
      </div>
    </form>
  );
};
